import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    vehicleConsumptionQuickViewReportSearchParams:{
        primaryFilter:{
            fromDate:'',
            toDate:'',
            searchVehicleIds:'',
            searchVehiclesNos:[],
        },
    },
    vehicleConsumptionQuickViewReportLists:{
        isLoading:false,
        dataLoaded:false,
        data:null,
        totalRecords:0,
        pageNo:0,
        perPageRecords:2000,
        vehicleConsumptionQuickViewReportError:'',
    },
    vehicleConsumptionQuickViewMoreDetails:{
        isLoading:false,
        dataLoaded:false,
        data:null,
        forVehicleId:'',
        forVehicleNo:'',
        moreDetailsFor:'',
        pageNo:0,
        perPageRecords:2000,
        vehicleConsumptionQuickViewMoreDetailsError:'',
        loadVehicleConsumptionQuickViewMoreDetails:false,
    },
    loadVehicleConsumptionQuickViewReportData: false,
}

const reportVehicleConsumptionQuickViewReportSlice = createSlice({
    name: "reportVehicleConsumptionQuickViewSlice",
    initialState,
    reducers: {
        vehicleConsumptionQuickViewReportPrimaryFiltersUpdates: (state, {payload}) => {
            if(payload?.fromDate && payload?.fromDate !== ''){
                state.vehicleConsumptionQuickViewReportSearchParams.primaryFilter.fromDate = payload.fromDate;
            }else if(payload?.fromDate === ''){
                state.vehicleConsumptionQuickViewReportSearchParams.primaryFilter.fromDate = '';
            }
            
            if(payload?.toDate && payload?.toDate !== ''){
                state.vehicleConsumptionQuickViewReportSearchParams.primaryFilter.toDate = payload.toDate;
            }else if(payload?.toDate === ''){
                state.vehicleConsumptionQuickViewReportSearchParams.primaryFilter.toDate = '';
            }
            
            if(payload?.searchVehicleIds && payload?.searchVehicleIds !== ''){
                state.vehicleConsumptionQuickViewReportSearchParams.primaryFilter.searchVehicleIds = payload.searchVehicleIds;
            }else if(payload?.searchVehicleIds === ''){
                state.vehicleConsumptionQuickViewReportSearchParams.primaryFilter.searchVehicleIds = '';
            }
            if(payload?.searchVehiclesNos && payload?.searchVehiclesNos?.length > 0){
                state.vehicleConsumptionQuickViewReportSearchParams.primaryFilter.searchVehiclesNos = payload.searchVehiclesNos;
            }else if(payload?.searchVehiclesNos?.length === 0){
                state.vehicleConsumptionQuickViewReportSearchParams.primaryFilter.searchVehiclesNos = [];
            }
            state.vehicleConsumptionQuickViewReportLists.dataLoaded = false;
        },
        vehicleConsumptionQuickViewReportGetData: (state, {payload}) => {
            state.loadVehicleConsumptionQuickViewReportData = payload;
        },
        vehicleConsumptionQuickViewReportLoadingPending: (state) => {
            state.vehicleConsumptionQuickViewReportLists.isLoading = true;
            state.vehicleConsumptionQuickViewReportLists.dataLoaded = false;
            state.vehicleConsumptionQuickViewReportLists.totalRecords = 0;
        },
        vehicleConsumptionQuickViewReportLoadingSuccess: (state, {payload}) => {
            state.vehicleConsumptionQuickViewReportLists.isLoading = false;
            state.vehicleConsumptionQuickViewReportLists.data = payload;
            state.vehicleConsumptionQuickViewReportLists.vehicleConsumptionQuickViewReportError = '';
            state.vehicleConsumptionQuickViewReportLists.dataLoaded = true;
            state.loadVehicleConsumptionQuickViewReportData = false;
        },
        vehicleConsumptionQuickViewReportLoadingFailed: (state, {payload}) => {
            state.vehicleConsumptionQuickViewReportLists.isLoading = false;
            state.vehicleConsumptionQuickViewReportLists.data = []
            state.vehicleConsumptionQuickViewReportLists.vehicleConsumptionQuickViewReportError = payload;
            state.vehicleConsumptionQuickViewReportLists.dataLoaded = true;
            state.loadVehicleConsumptionQuickViewReportData = false;
        },
        vehicleConsumptionQuickViewReportTotalRecordsUpdate: (state, {payload}) => {
            state.vehicleConsumptionQuickViewReportLists.totalRecords = payload.totalRecords || 0;
        },
        vehicleConsumptionQuickViewReportPageNoUpdate: (state, {payload}) => {
            state.vehicleConsumptionQuickViewReportLists.pageNo = payload;
            state.loadVehicleConsumptionQuickViewReportData = true;
        },
        vehicleConsumptionQuickViewReportPerPageRecordsUpdate: (state, {payload}) => {
            state.vehicleConsumptionQuickViewReportLists.perPageRecords = payload;
            state.vehicleConsumptionQuickViewReportLists.pageNo = 0;
            state.loadVehicleConsumptionQuickViewReportData = true;
        },
        vehicleConsumptionQuickViewReportListReset: (state,{payload}) => {
            state.vehicleConsumptionQuickViewReportLists.isLoading = false;
            state.vehicleConsumptionQuickViewReportLists.dataLoaded = false;
            state.vehicleConsumptionQuickViewReportLists.data = null;
            state.vehicleConsumptionQuickViewReportLists.totalRecords = 0;
            state.vehicleConsumptionQuickViewReportLists.pageNo = 0;
            state.vehicleConsumptionQuickViewReportLists.perPageRecords = 2000;
            state.vehicleConsumptionQuickViewReportLists.vehicleConsumptionQuickViewReportError = '';
            state.loadVehicleConsumptionQuickViewReportData = false;
        },
        vehicleConsumptionQuickViewMoreDetailsGetData: (state, {payload}) => {
            state.vehicleConsumptionQuickViewMoreDetails.loadVehicleConsumptionQuickViewMoreDetails = payload;
        },
        vehicleConsumptionQuickViewMoreDetailsLoadingPending: (state) => {
            state.vehicleConsumptionQuickViewMoreDetails.isLoading = true;
            state.vehicleConsumptionQuickViewMoreDetails.dataLoaded = false;
            state.vehicleConsumptionQuickViewMoreDetails.totalRecords = 0;
        },
        vehicleConsumptionQuickViewMoreDetailsLoadingSuccess: (state, {payload}) => {
            state.vehicleConsumptionQuickViewMoreDetails.isLoading = false;
            state.vehicleConsumptionQuickViewMoreDetails.data = payload;
            state.vehicleConsumptionQuickViewMoreDetails.vehicleConsumptionQuickViewMoreDetailsError = '';
            state.vehicleConsumptionQuickViewMoreDetails.dataLoaded = true;
            state.vehicleConsumptionQuickViewMoreDetails.loadVehicleConsumptionQuickViewMoreDetails = false;
        },
        vehicleConsumptionQuickViewMoreDetailsLoadingFailed: (state, {payload}) => {
            state.vehicleConsumptionQuickViewMoreDetails.isLoading = false;
            state.vehicleConsumptionQuickViewMoreDetails.data = []
            state.vehicleConsumptionQuickViewMoreDetails.vehicleConsumptionQuickViewMoreDetailsError = payload;
            state.vehicleConsumptionQuickViewMoreDetails.dataLoaded = true;
            state.vehicleConsumptionQuickViewMoreDetails.loadVehicleConsumptionQuickViewMoreDetails = false;
        },
        vehicleConsumptionQuickViewMoreDetailsUpdateVehicleId: (state, {payload}) => {
            state.vehicleConsumptionQuickViewMoreDetails.forVehicleId = payload.forVehicleId;
            state.vehicleConsumptionQuickViewMoreDetails.forVehicleNo = payload.forVehicleNo;
            state.vehicleConsumptionQuickViewMoreDetails.moreDetailsFor = payload.moreDetailsFor;
        }
    }
});

const { reducer, actions } = reportVehicleConsumptionQuickViewReportSlice;

export const {
    vehicleConsumptionQuickViewReportPrimaryFiltersUpdates, vehicleConsumptionQuickViewReportGetData,
    vehicleConsumptionQuickViewReportLoadingPending,vehicleConsumptionQuickViewReportLoadingSuccess,vehicleConsumptionQuickViewReportLoadingFailed,
    vehicleConsumptionQuickViewReportTotalRecordsUpdate, vehicleConsumptionQuickViewReportPageNoUpdate, vehicleConsumptionQuickViewReportPerPageRecordsUpdate,
    vehicleConsumptionQuickViewReportListReset, vehicleConsumptionQuickViewMoreDetailsGetData, vehicleConsumptionQuickViewMoreDetailsLoadingPending, 
    vehicleConsumptionQuickViewMoreDetailsLoadingSuccess, vehicleConsumptionQuickViewMoreDetailsLoadingFailed, vehicleConsumptionQuickViewMoreDetailsUpdateVehicleId
} = actions;

export default reducer;